import React from "react";

import IconPaymentCompleted from "./icon-payment-completed.png";
import { Button } from "antd";
import "./PaymentCompletedTab.scss";

import { withRouter } from "react-router-dom";

import { formatMoneyValue, getSearchParamValueByName } from "utils/utils";

class PaymentCompletedTab extends React.Component {
  onReturnToManageOrderClicked = () => {
    this.props.onReturnToManageOrderClicked()
  };

  render() {
    const payment = this.props.payment || {
      sourceValue: {
        currency: getSearchParamValueByName("sourceCurrency"),
        amount: +getSearchParamValueByName("sourceAmount")
      },
      targetValue: {
        currency: getSearchParamValueByName("targetCurrency"),
        amount: +getSearchParamValueByName("targetAmount")
      }
    };
    return (
      <div>
        <div className="bp-page-body payment-completed-page">
          <img
            src={IconPaymentCompleted}
            alt="Logo"
            className="payment-completed-image"
          />
          <h4>
            Your transfer of{" "}
            <span className="bp-bold">
              {formatMoneyValue(payment.sourceValue)}
            </span>{" "}
            to{" "}
            <span className="bp-bold">
              {formatMoneyValue(payment.targetValue)}
            </span>{" "}
            is setup
          </h4>
          <p className="description">
            We are waiting to receive your payment. You may track the status of
            your transfer by view transfer details.
          </p>
          <div className="bp-buttons-panel">
            <Button
              className="btn-wide-lg btn-skip"
              size="large"
              onClick={this.props.onDoAnotherTransferClicked}
            >
              Do another transfer
            </Button>
            <Button
              className="btn-wide-lg"
              size="large"
              type={"primary"}
              onClick={this.onReturnToManageOrderClicked}
            >
              Return to Manage Order
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PaymentCompletedTab);
